export type QuotationDetailFilters = {
  state: "all" | "selected" | "pending";
  offer: "all" | "offers" | "regular";
  category: string;
  supplierId: string;
  minimumPrice: number | null;
  maximumPrice: number | null;
};

export type QuotationDetailFilterableItem = {
  selected: boolean;
  isOffer: boolean;
  category: string;
  supplierId: string;
  price: number | null;
};

export const EMPTY_QUOTATION_DETAIL_FILTERS: QuotationDetailFilters = {
  state: "all",
  offer: "all",
  category: "all",
  supplierId: "all",
  minimumPrice: null,
  maximumPrice: null,
};

export function matchesQuotationDetailFilters(
  item: QuotationDetailFilterableItem,
  filters: QuotationDetailFilters,
) {
  const hasPriceFilter =
    filters.minimumPrice !== null || filters.maximumPrice !== null;
  return (
    (filters.state === "all" ||
      (filters.state === "selected" ? item.selected : !item.selected)) &&
    (filters.offer === "all" ||
      (filters.offer === "offers" ? item.isOffer : !item.isOffer)) &&
    (filters.category === "all" || item.category === filters.category) &&
    (filters.supplierId === "all" || item.supplierId === filters.supplierId) &&
    (!hasPriceFilter ||
      (item.price !== null &&
        (filters.minimumPrice === null || item.price >= filters.minimumPrice) &&
        (filters.maximumPrice === null || item.price <= filters.maximumPrice)))
  );
}

export function parseQuotationDetailPrice(value: string) {
  const normalized = value.trim();
  if (!normalized) return null;
  if (!/^(?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d{1,2})?$/.test(normalized)) {
    return undefined;
  }
  return Number(normalized.replaceAll(".", "").replace(",", "."));
}

export function countQuotationDetailFilters(filters: QuotationDetailFilters) {
  return [
    filters.state !== "all",
    filters.offer !== "all",
    filters.category !== "all",
    filters.supplierId !== "all",
    filters.minimumPrice !== null || filters.maximumPrice !== null,
  ].filter(Boolean).length;
}
